const state = () => ({
  status: null
})

const mutations = {
  set (state, { type, payload }) {
    state[type] = payload
  }
}

export { state, mutations }
